import { IconButton, ListItem, ListItemText, Tooltip } from '@mui/material'
import * as React from 'react'
import { ShareOutlined } from '@mui/icons-material'
import DialogComponent from '../DialogComponent/DialogComponent'
import ShareSocialComponent from './ShareSocialComponent'

interface IShareSocialDialogButtonProps {
  url: string
  title: string
  label: string
  buttonStyle?: React.CSSProperties
  iconStyle?: React.CSSProperties
  fontSize?: 'small'
  textContent?: string
  buttonColor?: 'primary' | 'secondary' | 'inherit'
  buttonSize?: 'small' | 'medium'
  onButtonClicked?: () => void
  useListItem?: boolean
  textStyle?: React.CSSProperties
}

export default function ShareSocialDialogButton(
  props: IShareSocialDialogButtonProps,
) {
  const [openDialog, setOpenDialog] = React.useState(false)

  const handleOpenDialog = () => {
    setOpenDialog(true)
    props.onButtonClicked && props.onButtonClicked()
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <Tooltip title={props.title}>
        {!props.useListItem ? (
          <IconButton
            size={props.buttonSize || 'medium'}
            style={{ ...props.buttonStyle }}
            onClick={handleOpenDialog}
            color={props.buttonColor || 'inherit'}
          >
            <ShareOutlined
              style={props.iconStyle}
              fontSize={props.fontSize || 'medium'}
            />
          </IconButton>
        ) : (
          <ListItem onClick={handleOpenDialog}>
            <ShareOutlined
              style={props.iconStyle}
              fontSize={props.fontSize || 'medium'}
            />
            <ListItemText style={{ ...props.textStyle }}>
              {' '}
              {props.textContent}
            </ListItemText>
          </ListItem>
        )}
      </Tooltip>
      <DialogComponent
        title="Share"
        open={openDialog}
        fullScreen={false}
        contentPadding={'0px'}
        dialogStyle={{ borderRadius: '15px !important' }}
        content={
          <div style={{ padding: '20px', backgroundColor: '#2d3e50' }}>
            <ShareSocialComponent
              url={props.url}
              title={props.title}
              label={props.label}
              shareUrlStyle={{ color: '#fff' }}
              copyIconStyle={{ color: '#fff' }}
            />
          </div>
        }
        onRequestClose={handleCloseDialog}
        hideTitleBar
      />
    </>
  )
}
